// Pass in a function you only want to be called once, and it will return a function
// that will only call the passed in function once the first time it is called,
// and returns the result of the first call on subsequent calls
export function doOnce<T extends Function>(fn: T): T {
  let func: Function | null = fn
  let result

  // @ts-ignore
  return (...args) => {
    if (func) {
      result = func(...args)
      func = null
    }

    return result
  }
}
